function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#E6AC39",
  d: "M7.967 15.941h-5.17c-.342 0-.569-.227-.569-.568 0-.34.227-.568.568-.568h5.17c.342 0 .569.227.569.568a.57.57 0 01-.568.568zm-.057-2.216H2.853c-.34 0-.568-.227-.568-.568v-.795c0-1.307-.455-2.67-1.307-3.92A5.431 5.431 0 01.07 4.463C.467 2.134 2.4.26 4.785.032A5.414 5.414 0 018.99 1.396c1.136 1.023 1.818 2.5 1.818 4.034 0 1.136-.341 2.16-.966 3.068-.852 1.193-1.307 2.557-1.307 3.92v.796c-.057.227-.284.511-.625.511zM3.478 12.59h3.92v-.227c0-1.591.512-3.182 1.535-4.546.511-.738.795-1.534.795-2.443 0-1.193-.511-2.386-1.42-3.182a4.388 4.388 0 00-3.296-1.08C3.194 1.34 1.603 2.817 1.32 4.636c-.17 1.136.057 2.215.682 3.125 1.023 1.42 1.534 3.01 1.534 4.602v.227h-.057z"
});

function SvgDarkModeOffToggleHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 16"
  }, props), _ref);
}

export default SvgDarkModeOffToggleHover;